<div class="p-5">
  <!-- Header -->
  <div
    class="flex flex-col md:flex-row justify-between items-start md:items-center mb-6"
  >
    <div>
      <h1 class="text-2xl font-bold text-gray-800 flex items-center">
        <mat-icon class="text-aguacate-green mr-2">pending_actions</mat-icon>
        {{
          isBinance
            ? "Transacciones Pendientes Binance"
            : "Transacciones Pendientes"
        }}
        <span
          *ngIf="transacciones.length"
          class="hidden md:inline text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full ml-2"
        >
          {{ transacciones.length }} registros
        </span>
      </h1>
      <span
        *ngIf="transacciones.length"
        class="md:hidden inline-block text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full mt-2"
      >
        {{ transacciones.length }} registros
      </span>
    </div>
  </div>

  <!-- Banner modo de tasa actual -->
  <div class="flex justify-center mb-4">
    <div
      class="rate-mode-banner"
      [ngClass]="{
        'rate-mode-banner--manual': fiatRateModeDisplay === 'MANUAL',
        'rate-mode-banner--binance': fiatRateModeDisplay === 'BINANCE',
        'rate-mode-banner--cbpay': fiatRateModeDisplay === 'CBPAY'
      }"
      [attr.aria-live]="'polite'"
    >
      <div class="rate-mode-banner__icon">
        <mat-icon *ngIf="fiatRateModeDisplay === 'MANUAL'">tune</mat-icon>
        <mat-icon *ngIf="fiatRateModeDisplay === 'BINANCE'">currency_exchange</mat-icon>
        <mat-icon *ngIf="fiatRateModeDisplay === 'CBPAY'">account_balance</mat-icon>
      </div>
      <div class="rate-mode-banner__text">
        <span class="rate-mode-banner__label">Modo de tasa actual</span>
        <strong class="rate-mode-banner__value">
          {{ fiatRateModeDisplay === 'MANUAL' ? 'Manual' : fiatRateModeDisplay === 'BINANCE' ? 'Binance' : 'CBPay' }}
        </strong>
      </div>
      <div class="rate-mode-banner__pulse" aria-hidden="true"></div>
    </div>
  </div>

  <!-- Filtros -->
  <div class="flex justify-center mb-6">
    <div
      class="w-full max-w-4xl bg-white p-6 rounded-xl shadow-lg border border-gray-100"
    >
      <div class="text-center mb-6">
        <h3
          class="text-lg font-semibold text-gray-700 flex items-center justify-center"
        >
          <mat-icon class="text-aguacate-green mr-2">filter_list</mat-icon>
          Filtros y Acciones
        </h3>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <mat-form-field appearance="outline" class="w-full modern-field">
          <mat-label>Buscar</mat-label>
          <mat-icon matPrefix>search</mat-icon>
          <input
            matInput
            type="text"
            (keyup)="doFilter($event)"
            placeholder="Nombre, ID, cuenta..."
          />
        </mat-form-field>

        <div class="flex items-center justify-center gap-3 flex-wrap">
          <button
            (click)="refreshRates()"
            style="
              display: inline-flex;
              align-items: center;
              gap: 8px;
              padding: 10px 36px;
              background: #1c593d;
              color: white;
              border: none;
              border-radius: 10px;
              font-weight: 700;
              font-size: 0.9rem;
              cursor: pointer;
              transition: background 0.2s ease;
            "
            onmouseover="this.style.background = '#059669'"
            onmouseout="this.style.background = '#1C593D'"
          >
            <mat-icon style="font-size: 18px; width: 18px; height: 18px"
              >refresh</mat-icon
            >
            Refrescar Tasas
          </button>
          <button
            (click)="loadTransactions()"
            style="
              display: inline-flex;
              align-items: center;
              gap: 8px;
              padding: 10px 36px;
              background: #1c593d;
              color: white;
              border: none;
              border-radius: 10px;
              font-weight: 700;
              font-size: 0.9rem;
              cursor: pointer;
              transition: background 0.2s ease;
            "
            onmouseover="this.style.background = '#059669'"
            onmouseout="this.style.background = '#1C593D'"
          >
            <mat-icon style="font-size: 18px; width: 18px; height: 18px"
              >sync</mat-icon
            >
            Refrescar Transacciones
          </button>
          <button
            *ngIf="!isObjectEmpty(cambios)"
            (click)="guardarSeleccion()"
            style="
              display: inline-flex;
              align-items: center;
              gap: 8px;
              padding: 10px 36px;
              background: #1c593d;
              color: white;
              border: none;
              border-radius: 10px;
              font-weight: 700;
              font-size: 0.9rem;
              cursor: pointer;
              transition: background 0.2s ease;
            "
            onmouseover="this.style.background = '#059669'"
            onmouseout="this.style.background = '#1C593D'"
          >
            <mat-icon style="font-size: 18px; width: 18px; height: 18px"
              >check</mat-icon
            >
            Guardar seleccion
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- ═══ Tabla Desktop ═══ -->
  <div
    class="hidden lg:block overflow-auto border rounded-lg shadow-md bg-white"
    *ngIf="dataSource"
  >
    <table mat-table [dataSource]="dataSource" class="w-full table-responsive">
      <!-- Columna Seleccion -->
      <ng-container matColumnDef="seleccion">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="text-center p-2 font-semibold"
          style="width: 50px"
        >
          Sel.
        </th>
        <td mat-cell *matCellDef="let row" class="text-center p-2">
          <mat-checkbox
            (change)="change($event, row.id)"
            [disabled]="checkEmailOperador(row.emailOperador) || isProcesandoRail(row)"
            [checked]="row.emailOperador ? true : false"
          ></mat-checkbox>
        </td>
      </ng-container>

      <!-- Columna ID -->
      <ng-container matColumnDef="id">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="text-center p-2 font-semibold"
        >
          ID
        </th>
        <td
          mat-cell
          *matCellDef="let row"
          class="text-center p-2 text-xs font-mono font-bold"
        >
          {{ row.id }}
        </td>
      </ng-container>

      <!-- Columna Ruta -->
      <ng-container matColumnDef="ruta">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="text-center p-2 font-semibold"
        >
          Ruta
        </th>
        <td mat-cell *matCellDef="let row" class="text-center p-2 text-xs">
          {{ row.paisOrigen }} - {{ row.paisDestino }}
        </td>
      </ng-container>

      <!-- Columna ClienteID -->
      <ng-container matColumnDef="idUser">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="text-center p-2 font-semibold"
        >
          ClienteID
        </th>
        <td
          mat-cell
          *matCellDef="let row"
          class="text-center p-2 text-xs font-mono font-bold"
        >
          {{ row.userId }}
        </td>
      </ng-container>

      <!-- Columna Remitente -->
      <ng-container matColumnDef="userId">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="text-left p-2 font-semibold"
        >
          Remitente
        </th>
        <td
          mat-cell
          *matCellDef="let row"
          class="text-left p-2 text-xs font-medium"
        >
          {{ row.usuario.nombre }} {{ row.usuario.apellidos }}
        </td>
      </ng-container>

      <!-- Columna Beneficiario -->
      <ng-container matColumnDef="cuentaBeneficiarioId">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="text-left p-2 font-semibold"
        >
          Beneficiario
        </th>
        <td mat-cell *matCellDef="let row" class="text-left p-2">
          <div class="text-xs font-medium">
            {{ row.cuentaBeneficiario.nombre }}
            {{ row.cuentaBeneficiario.apellidos }}
          </div>
        </td>
      </ng-container>

      <!-- Columna Tipo Cuenta Beneficiario -->
      <ng-container matColumnDef="tipoCuentaBeneficiarioId">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="text-center p-2 font-semibold hide-on-mobile"
        >
          Tipo Benef.
        </th>
        <td
          mat-cell
          *matCellDef="let row"
          class="text-center p-2 text-xs hide-on-mobile"
        >
          {{
            row.cuentaBeneficiario.movilPay === 1
              ? "MovilPay"
              : "Cuenta bancaria"
          }}
        </td>
      </ng-container>

      <!-- Columna Cuenta Trabajo -->
      <ng-container matColumnDef="cuentaTrabajo">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="text-center p-2 font-semibold"
        >
          Cta. Trabajo
        </th>
        <td
          mat-cell
          *matCellDef="let row"
          class="text-center p-2 text-xs font-medium"
        >
          {{ row.cuentaTrabajo?.nombre || "Sin asignar" }}
        </td>
      </ng-container>

      <!-- Columna DNI -->
      <ng-container matColumnDef="beneficiarioDNI">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="text-center p-2 font-semibold"
        >
          DNI
        </th>
        <td
          mat-cell
          *matCellDef="let row"
          class="text-center p-2 text-xs font-mono"
        >
          {{ row.cuentaBeneficiario.numeroID }}
        </td>
      </ng-container>

      <!-- Columna Banco Destino -->
      <ng-container matColumnDef="bancoDestino">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="text-center p-2 font-semibold"
        >
          Banco
        </th>
        <td mat-cell *matCellDef="let row" class="text-center p-2 text-xs">
          {{ row.cuentaBeneficiario.banco?.nombre || "Sin banco" }}
        </td>
      </ng-container>

      <!-- Columna Tipo Cuenta -->
      <ng-container matColumnDef="beneficiarioTipoCuenta">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="text-center p-2 font-semibold hide-on-mobile"
        >
          Tipo Cta.
        </th>
        <td
          mat-cell
          *matCellDef="let row"
          class="text-center p-2 text-xs hide-on-mobile"
        >
          {{ row.cuentaBeneficiario.tipoCuenta?.nombre?.toUpperCase() || "" }}
        </td>
      </ng-container>

      <!-- Columna Numero Cuenta -->
      <ng-container matColumnDef="numeroCuenta">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="text-center p-2 font-semibold"
        >
          Cuenta
        </th>
        <td
          mat-cell
          *matCellDef="let row"
          class="text-center p-2 text-xs text-blue-600 font-semibold"
        >
          {{ row.cuentaBeneficiario.numeroCuenta }}
        </td>
      </ng-container>

      <!-- Columna Monto Destino -->
      <ng-container matColumnDef="totalMonedaDestino">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="text-right p-2 font-semibold"
          style="min-width: 160px"
        >
          Monto Destino
        </th>
        <td mat-cell *matCellDef="let row" class="text-right p-2">
          <div class="flex items-center justify-end gap-1">
            <span class="text-xs font-bold text-green-600">
              {{ row.totalMonedaDestino | currency: "$" : "symbol" : "1.0-2" }}
              {{ row.monedaDestino }}
            </span>
            <button
              [cdkCopyToClipboard]="
                formatCurrencyForCopy(row.totalMonedaDestino)
              "
              title="Copiar monto"
              style="
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 30px;
                height: 30px;
                border: 1px solid #d1d5db;
                border-radius: 6px;
                background: white;
                cursor: pointer;
              "
            >
              <mat-icon
                style="
                  font-size: 16px;
                  width: 16px;
                  height: 16px;
                  color: #1c593d;
                "
                >content_copy</mat-icon
              >
            </button>
          </div>
        </td>
      </ng-container>

      <!-- Columna Precio Venta (solo Binance) -->
      <ng-container matColumnDef="precioVenta">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="text-center p-2 font-semibold"
        >
          P. Venta
        </th>
        <td
          mat-cell
          *matCellDef="let row"
          class="text-center p-2 text-xs font-bold text-purple-600"
        >
          {{ currentRate() | number: "1.2-3" }}
        </td>
      </ng-container>

      <!-- Columna Precio Compra -->
      <ng-container matColumnDef="pago">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="text-center p-2 font-semibold"
          style="min-width: 180px"
        >
          P. Compra
        </th>
        <td mat-cell *matCellDef="let row" class="text-center p-2">
          <div class="flex items-center gap-1 justify-center">
            <mat-form-field style="margin-top: 20px; max-width: 120px">
              <mat-label>Precio</mat-label>
              <input
                matInput
                matInputCommified
                appOnlynumber
                [id]="'valorCompra' + row.id"
                [(ngModel)]="row.precio_compra"
                [disabled]="disableButton(row.emailOperador) || isProcesandoRail(row)"
              />
              <span matTextPrefix>$&nbsp;</span>
            </mat-form-field>
            <button
              title="Guardar precio"
              [disabled]="disableButton(row.emailOperador) || isProcesandoRail(row)"
              (click)="setPurchaseValue(row.id, row.id)"
              style="
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 30px;
                height: 30px;
                border: 1px solid #d1d5db;
                border-radius: 6px;
                background: white;
                cursor: pointer;
              "
            >
              <mat-icon
                style="
                  font-size: 16px;
                  width: 16px;
                  height: 16px;
                  color: #1c593d;
                "
                >save</mat-icon
              >
            </button>
          </div>
        </td>
      </ng-container>

      <!-- Columna Acciones -->
      <ng-container matColumnDef="acciones" stickyEnd>
        <th
          mat-header-cell
          *matHeaderCellDef
          class="text-center p-2 font-semibold"
        >
          Acciones
        </th>
        <td mat-cell *matCellDef="let row" class="text-center p-2">
          <!-- Candado visual: si el rail automático (N58 / Banco Plaza) está
               procesando la tx, se ocultan las acciones y se muestra un chip.
               Como la query ASSIGNED sólo trae POR_PROCESAR, en cuanto el rail
               resuelve la fila deja de venir y el candado desaparece solo. -->
          <!-- Rail procesando: se ocultan asignar/aprobar/editar/reasignar,
               pero se DEJA disponible Rechazar (decisión de negocio). -->
          <div
            *ngIf="isProcesandoRail(row)"
            class="flex items-center gap-1 justify-center flex-wrap"
          >
            <span
              style="
                display: inline-flex;
                align-items: center;
                gap: 4px;
                padding: 4px 10px;
                background: #fef9c3;
                color: #854d0e;
                border: 1px solid #fde047;
                border-radius: 9999px;
                font-size: 0.7rem;
                font-weight: 700;
                white-space: nowrap;
              "
            >
              <mat-icon style="font-size: 14px; width: 14px; height: 14px"
                >hourglass_top</mat-icon
              >
              Procesando · {{ procesandoRail(row) }}
            </span>
            <button
              title="Rechazar"
              (click)="openRejectTransactionModal(row)"
              style="
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 30px;
                height: 30px;
                border: 1px solid #fecaca;
                border-radius: 6px;
                background: #fef2f2;
                cursor: pointer;
              "
            >
              <mat-icon
                style="
                  font-size: 16px;
                  width: 16px;
                  height: 16px;
                  color: #dc2626;
                "
                >close</mat-icon
              >
            </button>
          </div>
          <div
            *ngIf="!isProcesandoRail(row)"
            class="flex gap-1 justify-center flex-wrap"
          >
            <button
              title="Copiar datos"
              [disabled]="disableButton(row.emailOperador)"
              (click)="copy(row)"
              style="
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 30px;
                height: 30px;
                border: 1px solid #d1d5db;
                border-radius: 6px;
                background: white;
                cursor: pointer;
              "
              [style.opacity]="disableButton(row.emailOperador) ? '0.4' : '1'"
            >
              <mat-icon
                style="
                  font-size: 16px;
                  width: 16px;
                  height: 16px;
                  color: #1c593d;
                "
                >content_copy</mat-icon
              >
            </button>
            <button
              title="Marcar como pagada"
              [disabled]="
                disableButton(row.emailOperador) ||
                !row.precio_compra ||
                row.precio_compra === '0'
              "
              (click)="openSendTransactionModal(row)"
              style="
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 30px;
                height: 30px;
                border: 1px solid #bbf7d0;
                border-radius: 6px;
                background: #f0fdf4;
                cursor: pointer;
              "
              [style.opacity]="
                disableButton(row.emailOperador) ||
                !row.precio_compra ||
                row.precio_compra === '0'
                  ? '0.4'
                  : '1'
              "
            >
              <mat-icon
                style="
                  font-size: 16px;
                  width: 16px;
                  height: 16px;
                  color: #16a34a;
                "
                >done</mat-icon
              >
            </button>
            <button
              title="Editar"
              [disabled]="disableButton(row.emailOperador)"
              (click)="openEditTransactionModal(row)"
              style="
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 30px;
                height: 30px;
                border: 1px solid #bfdbfe;
                border-radius: 6px;
                background: #eff6ff;
                cursor: pointer;
              "
              [style.opacity]="disableButton(row.emailOperador) ? '0.4' : '1'"
            >
              <mat-icon
                style="
                  font-size: 16px;
                  width: 16px;
                  height: 16px;
                  color: #2563eb;
                "
                >edit</mat-icon
              >
            </button>
            <button
              title="Rechazar"
              [disabled]="disableButton(row.emailOperador)"
              (click)="openRejectTransactionModal(row)"
              style="
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 30px;
                height: 30px;
                border: 1px solid #fecaca;
                border-radius: 6px;
                background: #fef2f2;
                cursor: pointer;
              "
              [style.opacity]="disableButton(row.emailOperador) ? '0.4' : '1'"
            >
              <mat-icon
                style="
                  font-size: 16px;
                  width: 16px;
                  height: 16px;
                  color: #dc2626;
                "
                >close</mat-icon
              >
            </button>
            <button
              title="Reasignar"
              [disabled]="disableButton(row.emailOperador)"
              (click)="reasign(row)"
              style="
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 30px;
                height: 30px;
                border: 1px solid #ddd6fe;
                border-radius: 6px;
                background: #f5f3ff;
                cursor: pointer;
              "
              [style.opacity]="disableButton(row.emailOperador) ? '0.4' : '1'"
            >
              <mat-icon
                style="
                  font-size: 16px;
                  width: 16px;
                  height: 16px;
                  color: #7c3aed;
                "
                >edit_note</mat-icon
              >
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="hover:bg-gray-100 transition-colors"
      ></tr>
    </table>
  </div>

  <!-- ═══ Mobile / Tablet Cards (Acordeon) ═══ -->
  <div class="lg:hidden">
    <div
      *ngIf="!dataSource || transacciones.length === 0"
      style="text-align: center; padding: 40px 20px"
    >
      <mat-icon
        style="color: #d1d5db; font-size: 48px; width: 48px; height: 48px"
        >pending_actions</mat-icon
      >
      <p style="color: #6b7280; font-size: 0.9rem; margin-top: 8px">
        No se encontraron transacciones
      </p>
    </div>

    <div
      *ngFor="let row of transacciones"
      style="
        border: 1px solid #e5e7eb;
        border-radius: 10px;
        overflow: hidden;
        margin-bottom: 8px;
      "
      [style.border-color]="expandedCardId === row.id ? '#1C593D' : '#e5e7eb'"
    >
      <!-- Card header (siempre visible) -->
      <div
        (click)="toggleCard(row.id)"
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 10px 14px;
          cursor: pointer;
          user-select: none;
        "
        [style.background]="expandedCardId === row.id ? '#f0fdf4' : '#f9fafb'"
      >
        <div
          style="
            display: flex;
            align-items: center;
            gap: 6px;
            flex-wrap: wrap;
            flex: 1;
            min-width: 0;
          "
        >
          <mat-checkbox
            (change)="change($event, row.id)"
            [disabled]="checkEmailOperador(row.emailOperador || '') || isProcesandoRail(row)"
            [checked]="row.emailOperador ? true : false"
            (click)="$event.stopPropagation()"
          ></mat-checkbox>
          <span
            style="
              background: #dcfce7;
              color: #1e5a3f;
              font-size: 0.7rem;
              padding: 2px 7px;
              border-radius: 10px;
              font-weight: 600;
            "
          >
            #{{ row.id }}
          </span>
          <span
            style="
              font-size: 0.65rem;
              color: #6b7280;
              font-weight: 500;
              white-space: nowrap;
            "
          >
            {{ row.paisOrigen }} → {{ row.paisDestino }}
          </span>
          <span
            style="
              font-size: 0.7rem;
              color: #374151;
              font-weight: 500;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            "
          >
            {{ row.usuario.nombre }} {{ row.usuario.apellidos }}
          </span>
          <span
            style="
              font-size: 0.7rem;
              color: #1e5a3f;
              font-weight: 700;
              white-space: nowrap;
            "
          >
            {{ row.totalMonedaDestino | currency: "$" : "symbol" : "1.0-2" }}
          </span>
          <span
            *ngIf="isProcesandoRail(row)"
            style="
              display: inline-flex;
              align-items: center;
              gap: 3px;
              padding: 2px 7px;
              background: #fef9c3;
              color: #854d0e;
              border: 1px solid #fde047;
              border-radius: 10px;
              font-size: 0.65rem;
              font-weight: 700;
              white-space: nowrap;
            "
          >
            <mat-icon style="font-size: 12px; width: 12px; height: 12px"
              >hourglass_top</mat-icon
            >
            Procesando · {{ procesandoRail(row) }}
          </span>
        </div>

        <mat-icon
          style="
            color: #6b7280;
            font-size: 20px;
            width: 20px;
            height: 20px;
            transition: transform 0.2s ease;
            flex-shrink: 0;
            margin-left: 4px;
          "
          [style.transform]="
            expandedCardId === row.id ? 'rotate(180deg)' : 'rotate(0)'
          "
        >
          expand_more
        </mat-icon>
      </div>

      <!-- Card body (colapsable) -->
      <div *ngIf="expandedCardId === row.id">
        <div style="padding: 12px 16px; background: white">
          <div class="grid grid-cols-2 gap-x-12 gap-y-1">
            <div
              style="
                padding: 4px 0;
                border-bottom: 1px solid #f3f4f6;
                grid-column: 1 / -1;
              "
            >
              <span style="color: #6b7280; font-size: 0.75rem; display: block"
                >Remitente</span
              >
              <span
                style="color: #111827; font-weight: 500; font-size: 0.85rem"
              >
                {{ row.usuario.nombre }} {{ row.usuario.apellidos }}
              </span>
              <span
                style="
                  color: #111827;
                  font-weight: 700;
                  font-size: 0.8rem;
                  font-family: monospace;
                  margin-left: 6px;
                "
                >ID: {{ row.userId }}</span
              >
            </div>

            <div
              style="
                padding: 4px 0;
                border-bottom: 1px solid #f3f4f6;
                grid-column: 1 / -1;
              "
            >
              <span style="color: #6b7280; font-size: 0.75rem; display: block"
                >Beneficiario</span
              >
              <span
                style="color: #111827; font-weight: 500; font-size: 0.85rem"
              >
                {{ row.cuentaBeneficiario.nombre }}
                {{ row.cuentaBeneficiario.apellidos }}
              </span>
              <div style="color: #2563eb; font-size: 0.8rem; font-weight: 600">
                {{ row.cuentaBeneficiario.numeroCuenta }}
              </div>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6">
              <span style="color: #6b7280; font-size: 0.75rem; display: block"
                >DNI</span
              >
              <span
                style="
                  color: #111827;
                  font-weight: 500;
                  font-size: 0.85rem;
                  font-family: monospace;
                "
              >
                {{ row.cuentaBeneficiario.numeroID }}
              </span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6">
              <span style="color: #6b7280; font-size: 0.75rem; display: block"
                >Banco</span
              >
              <span
                style="color: #111827; font-weight: 500; font-size: 0.85rem"
              >
                {{ row.cuentaBeneficiario.banco?.nombre || "Sin banco" }}
              </span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6">
              <span style="color: #6b7280; font-size: 0.75rem; display: block"
                >Tipo cuenta</span
              >
              <span
                style="color: #111827; font-weight: 500; font-size: 0.85rem"
              >
                {{
                  row.cuentaBeneficiario.tipoCuenta?.nombre?.toUpperCase() || ""
                }}
              </span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6">
              <span style="color: #6b7280; font-size: 0.75rem; display: block"
                >Cuenta trabajo</span
              >
              <span
                style="color: #111827; font-weight: 500; font-size: 0.85rem"
              >
                {{ row.cuentaTrabajo?.nombre || "Sin asignar" }}
              </span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6">
              <span style="color: #6b7280; font-size: 0.75rem; display: block"
                >Monto destino</span
              >
              <span style="color: #1e5a3f; font-weight: 700; font-size: 0.9rem">
                {{
                  row.totalMonedaDestino | currency: "$" : "symbol" : "1.0-2"
                }}
                {{ row.monedaDestino }}
              </span>
            </div>

            <div style="padding: 4px 0; border-bottom: 1px solid #f3f4f6">
              <span style="color: #6b7280; font-size: 0.75rem; display: block"
                >Precio venta</span
              >
              <span style="color: #7c3aed; font-weight: 700; font-size: 0.9rem">
                {{ currentRate() | number: "1.2-3" }}
              </span>
            </div>

            <!-- Precio compra input -->
            <div
              style="
                padding: 4px 0;
                border-bottom: 1px solid #f3f4f6;
                grid-column: 1 / -1;
              "
            >
              <span
                style="
                  color: #6b7280;
                  font-size: 0.75rem;
                  display: block;
                  margin-bottom: 4px;
                "
                >Precio compra</span
              >
              <div class="flex items-center gap-2">
                <mat-form-field
                  appearance="outline"
                  class="modern-field"
                  style="max-width: 160px"
                >
                  <mat-label>Precio</mat-label>
                  <input
                    matInput
                    matInputCommified
                    appOnlynumber
                    [id]="'valorCompraM' + row.id"
                    [(ngModel)]="row.precio_compra"
                    [disabled]="disableButton(row.emailOperador || '') || isProcesandoRail(row)"
                  />
                  <span matTextPrefix>$&nbsp;</span>
                </mat-form-field>
                <button
                  title="Guardar precio"
                  [disabled]="disableButton(row.emailOperador || '') || isProcesandoRail(row)"
                  (click)="setPurchaseValue(row.id, row.id)"
                  style="
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    width: 30px;
                    height: 30px;
                    border: 1px solid #d1d5db;
                    border-radius: 6px;
                    background: white;
                    cursor: pointer;
                  "
                >
                  <mat-icon
                    style="
                      font-size: 16px;
                      width: 16px;
                      height: 16px;
                      color: #1c593d;
                    "
                    >save</mat-icon
                  >
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Botones de accion -->
        <!-- Candado visual mobile: si el rail automático procesa la tx, se
             ocultan las acciones y se muestra el chip "Procesando". -->
        <div
          *ngIf="isProcesandoRail(row)"
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
            padding: 12px 16px;
            background: #fffbeb;
            border-top: 1px solid #f3f4f6;
          "
        >
          <span
            style="
              display: inline-flex;
              align-items: center;
              gap: 5px;
              padding: 6px 12px;
              background: #fef9c3;
              color: #854d0e;
              border: 1px solid #fde047;
              border-radius: 9999px;
              font-size: 0.8rem;
              font-weight: 700;
            "
          >
            <mat-icon style="font-size: 16px; width: 16px; height: 16px"
              >hourglass_top</mat-icon
            >
            Procesando · {{ procesandoRail(row) }}
          </span>
          <!-- Rail procesando: solo se permite Rechazar. -->
          <button
            (click)="openRejectTransactionModal(row)"
            style="
              display: flex;
              align-items: center;
              gap: 4px;
              padding: 8px 12px;
              background: #ef4444;
              color: white;
              border: none;
              border-radius: 8px;
              font-size: 0.75rem;
              font-weight: 600;
              cursor: pointer;
            "
          >
            <mat-icon style="font-size: 14px; width: 14px; height: 14px"
              >close</mat-icon
            >
            Rechazar
          </button>
        </div>
        <div
          *ngIf="!isProcesandoRail(row)"
          style="
            display: flex;
            gap: 6px;
            padding: 10px 16px;
            background: #f9fafb;
            border-top: 1px solid #f3f4f6;
            flex-wrap: wrap;
          "
        >
          <button
            (click)="copy(row)"
            [disabled]="disableButton(row.emailOperador || '')"
            style="
              display: flex;
              align-items: center;
              gap: 4px;
              padding: 8px 12px;
              background: #1c593d;
              color: white;
              border: none;
              border-radius: 8px;
              font-size: 0.75rem;
              font-weight: 600;
              cursor: pointer;
              flex: 1;
              justify-content: center;
              min-width: 0;
            "
            [style.opacity]="
              disableButton(row.emailOperador || '') ? '0.5' : '1'
            "
          >
            <mat-icon style="font-size: 14px; width: 14px; height: 14px"
              >content_copy</mat-icon
            >
            Copiar
          </button>
          <button
            (click)="openSendTransactionModal(row)"
            [disabled]="
              disableButton(row.emailOperador || '') ||
              !row.precio_compra ||
              row.precio_compra === 0
            "
            style="
              display: flex;
              align-items: center;
              gap: 4px;
              padding: 8px 12px;
              background: #15803d;
              color: white;
              border: none;
              border-radius: 8px;
              font-size: 0.75rem;
              font-weight: 600;
              cursor: pointer;
              flex: 1;
              justify-content: center;
              min-width: 0;
            "
            [style.opacity]="
              disableButton(row.emailOperador || '') ||
              !row.precio_compra ||
              row.precio_compra === 0
                ? '0.5'
                : '1'
            "
          >
            <mat-icon style="font-size: 14px; width: 14px; height: 14px"
              >done</mat-icon
            >
            Pagar
          </button>
          <button
            (click)="openEditTransactionModal(row)"
            [disabled]="disableButton(row.emailOperador || '')"
            style="
              display: flex;
              align-items: center;
              gap: 4px;
              padding: 8px 12px;
              background: #6b7280;
              color: white;
              border: none;
              border-radius: 8px;
              font-size: 0.75rem;
              font-weight: 600;
              cursor: pointer;
              flex: 1;
              justify-content: center;
              min-width: 0;
            "
            [style.opacity]="
              disableButton(row.emailOperador || '') ? '0.5' : '1'
            "
          >
            <mat-icon style="font-size: 14px; width: 14px; height: 14px"
              >edit</mat-icon
            >
            Editar
          </button>
          <button
            (click)="openRejectTransactionModal(row)"
            [disabled]="disableButton(row.emailOperador || '')"
            style="
              display: flex;
              align-items: center;
              gap: 4px;
              padding: 8px 12px;
              background: #ef4444;
              color: white;
              border: none;
              border-radius: 8px;
              font-size: 0.75rem;
              font-weight: 600;
              cursor: pointer;
              flex: 1;
              justify-content: center;
              min-width: 0;
            "
            [style.opacity]="
              disableButton(row.emailOperador || '') ? '0.5' : '1'
            "
          >
            <mat-icon style="font-size: 14px; width: 14px; height: 14px"
              >close</mat-icon
            >
            Rechazar
          </button>
          <button
            (click)="reasign(row)"
            [disabled]="disableButton(row.emailOperador || '')"
            style="
              display: flex;
              align-items: center;
              gap: 4px;
              padding: 8px 12px;
              background: #7c3aed;
              color: white;
              border: none;
              border-radius: 8px;
              font-size: 0.75rem;
              font-weight: 600;
              cursor: pointer;
              flex: 1;
              justify-content: center;
              min-width: 0;
            "
            [style.opacity]="
              disableButton(row.emailOperador || '') ? '0.5' : '1'
            "
          >
            <mat-icon style="font-size: 14px; width: 14px; height: 14px"
              >edit_note</mat-icon
            >
            Reasignar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Notificación temporal: cambio de tasa detectado.
       Posicionada fixed sobre la parte inferior del viewport para no
       afectar el flow del documento cuando aparece. Stacking context
       propio vía z-index alto. -->
  <div
    class="rate-mode-toast-floating"
    *ngIf="rateModeChange"
    [@slideToast]
    role="status"
  >
    <div class="rate-mode-toast">
      <mat-icon class="rate-mode-toast__icon">campaign</mat-icon>
      <div class="rate-mode-toast__body">
        <strong class="rate-mode-toast__title">La tasa cambió</strong>
        <span class="rate-mode-toast__detail">
          de
          <span
            class="rate-mode-toast__chip"
            [ngClass]="{
              'rate-mode-toast__chip--manual': rateModeChange.from === 'MANUAL',
              'rate-mode-toast__chip--binance': rateModeChange.from === 'BINANCE',
              'rate-mode-toast__chip--cbpay': rateModeChange.from === 'CBPAY'
            }"
          >
            {{ rateModeChange.from === 'MANUAL' ? 'Manual' : rateModeChange.from === 'BINANCE' ? 'Binance' : 'CBPay' }}
          </span>
          <mat-icon class="rate-mode-toast__arrow">arrow_forward</mat-icon>
          a
          <span
            class="rate-mode-toast__chip"
            [ngClass]="{
              'rate-mode-toast__chip--manual': rateModeChange.to === 'MANUAL',
              'rate-mode-toast__chip--binance': rateModeChange.to === 'BINANCE',
              'rate-mode-toast__chip--cbpay': rateModeChange.to === 'CBPAY'
            }"
          >
            {{ rateModeChange.to === 'MANUAL' ? 'Manual' : rateModeChange.to === 'BINANCE' ? 'Binance' : 'CBPay' }}
          </span>
        </span>
      </div>
      <button
        type="button"
        class="rate-mode-toast__close"
        (click)="dismissRateModeChange()"
        aria-label="Cerrar notificación"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</div>
